export const AUTH_ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot_password',
  REGISTRATION: '/register',
  TERMS: '/terms',
  EMULATE_USER: '/emulate_user',
  TERMS_OF_USE: '/terms-of-use',
  PRIVACY_POLICY: '/privacy-policy',
}
